import { Fragment, PropsWithChildren, useState } from 'react';

import { Dialog, DialogContent, DialogProps } from '@opositandopn/ui';

import { BaseComponentProps } from '../../../types/base-component.types';

import styles from './BackdropDialog.module.scss';

export type ContainerProps = BaseComponentProps & {
  open: boolean;
  onClose: () => void;
};

function BackdropDialog(props: PropsWithChildren<DialogProps>) {
  // What is inside stays mounted through the closing fade, so an opening that happens
  // during it would otherwise pick up whatever the previous one left behind — the
  // assessment attempt it had loaded, the question it was on. Counting the openings and
  // keying on the count starts each one from scratch, while leaving the one on its way
  // out alone until it unmounts.
  const [openings, setOpenings] = useState(0);
  const [wasOpen, setWasOpen] = useState(props.open);

  if (props.open !== wasOpen) {
    setWasOpen(props.open);

    if (props.open) {
      setOpenings((count) => count + 1);
    }
  }

  return (
    <Dialog {...props}>
      <DialogContent className={styles['backdrop']}>
        <Fragment key={openings}>{props.children}</Fragment>
      </DialogContent>
    </Dialog>
  );
}

export { BackdropDialog };
